/** `PartnerStitchPayoutType` in para-node. */
export enum PayoutType {
  Financed = 'financed',
  NonFinanced = 'non_financed',
}

/**
 * `PaymentPeriodType` in para-node has a sixth member, `custom`, deliberately omitted here:
 * it has no defined admin-facing meaning, so it is never offered. It is still *preserved* on
 * read and write — see `parseVendorFee` in `utils/paymentConfig.ts`.
 */
export enum PaymentPeriodType {
  PerPayment = 'per_payment',
  PerDay = 'per_day',
  PerWeek = 'per_week',
  PerMonth = 'per_month',
  PerYear = 'per_year',
}

/** `PayoutDestinationType` in para-node. */
export enum PayoutDestination {
  BankAccount = 'bank_account',
  Card = 'card',
}

/** `PartnerInvoiceBreakdownContractorType` in para-node. */
export enum ContractorType {
  McLiteMaster = 'mc_lite_master',
  McLiteSubcontractor = 'mc_lite_subcontractor',
  Direct = 'direct',
}
